// Change document location to a URL, or find or create a container and fill it with URL.
Jelly.Handlers.Visit_Link = function(Parameters)
{
	// Parameters - URL, Container, Alias, Values, On_Complete, URL_Variables, Calling_Element, Calling_Reference, 2019_Theme
	// TODO - Calling Element? 	

	// Get URL
	var URL = Parameters["URL"];

	var Is_External_Link = window.location.hostname != $('<a/>').attr("href", URL).get(0).hostname;

	// Third party cookie workaround
	if (!Jelly.Utilities.Detect_Feature('cookies') && !Is_External_Link){
		Session_ID = document.querySelector('meta[name="withfriends:si"]').content;
		Session_Code = document.querySelector('meta[name="withfriends:sc"]').content;
		if (Session_ID && Session_Code){
			if (!Parameters.URL_Variables)
				Parameters.URL_Variables = {}
			Parameters.URL_Variables.si = Session_ID;
			Parameters.URL_Variables.sc = Session_Code;
		}
	}
	
	if (Parameters["URL_Variables"])
	{
		// Build URL Variables string	
		/// TODO: Maybe continue to pass these in
		var URL_Variable_Strings = [];
		for (URL_Variable_Name in Parameters["URL_Variables"])
		{
			var URL_Variable_Value = Parameters["URL_Variables"][URL_Variable_Name];
			URL_Variable_Strings.push(URL_Variable_Name + "=" + URL_Variable_Value);
		}
		var URL_Variables_String = URL_Variable_Strings.join(",");
		
		if (!URL.split("/").pop().includes(":")) {
			if (URL.charAt(URL.length - 1) !== "/")
				URL+= "/";
			URL += ":";
		}
		else 
			URL += ",";
		URL += URL_Variables_String;
	}
	
	/*
	if (Jelly.URL.Is_Absolute(Parameters["URL"]))
		var URL = Parameters["URL"]

	// Create URL if necessary...			
	else
	{
		// TODO prepend Directory
		var URL = Jelly.URL.Format(Parameters["URL"], "raw");
	 
		// Turn array of values into a query string
		if (Parameters["Values"])
			URL += ":" .  Jelly.Utilities.Serialize(Parameters["Values"], ",");
	}
	*/
	
	// If no container is specified, set the browser location to an anchor based URL, and the browser location listener will refresh the default container
	if (!Parameters["Container"])
	{
		// Check if the URL is absolute
		if (Jelly.URL.Is_Absolute(URL)) {
			const urlObject = new window.URL(URL);
			if (urlObject.hostname !== window.location.hostname) {
				window.location.href = URL; // Redirect to the external URL
			} else {
				window.history.pushState(null, null, URL); // Update the browser's history state for internal absolute links
			}
		} else {
			window.history.pushState(null, null, URL); // Update the browser's history state for internal relative links
		}
	}
	
	// If a container is specified, combine the  URL & Values in a raw URL, and pass that to an interface function for the specified container.
	else
	{		
		// Handle link according to container.
		switch (Parameters["Container"].toLowerCase())
		{
			// Inspector
			case "inspector":
			{
				Jelly.Interface.Create_Inspector({URL:URL});
				break;
			}
			
			// Windows
			case "quick_window":
			case "interstitial":
			case "window":
			{
				var Window_Parameters = {Alias: Parameters["Alias"], URL: URL, Calling_Element: Parameters["Calling_Element"], Calling_Reference: Parameters["Calling_Reference"], Container: Parameters["Container"]};
				if (Parameters.Keep_Unlocked)
					Window_Parameters.Keep_Unlocked = Parameters.Keep_Unlocked;
				Jelly.Interface.Create_Window(Window_Parameters);
				break;
			}
			
			case 'new':
			{
				window.open(URL);
				break;
			}

			// case 'swipe':
			case 'overlay':
			case 'modal': { 
				var Modal_Parameters = {
					Alias: Parameters["Alias"], 
					URL: URL, 
					Calling_Element: Parameters["Calling_Element"], 
					Calling_Reference: Parameters["Calling_Reference"]
				};

				if (Parameters["2019_Theme"])
						Modal_Parameters["2019_Theme"] = Parameters["2019_Theme"];

				if (Parameters.Keep_Unlocked)
					Modal_Parameters.Keep_Unlocked = Parameters.Keep_Unlocked;

				if (Parameters.Force_Minimal)
					Modal_Parameters.Force_Minimal = Parameters.Force_Minimal;

				if (Parameters.Force_Slow)
					Modal_Parameters.Force_Slow = Parameters.Force_Slow;
				
				if (Parameters["Container"].toLowerCase() == 'overlay')
					Modal_Parameters["Direction"] = "Up";
				else
					Modal_Parameters["Direction"] = "Right";

				Jelly.Interface.Create_Modal(Modal_Parameters);
				break;
			}

			case "parent":
			{
				var Fill_Parameters = {
						Element: Parameters["Calling_Element"]
					, Reference: Parameters["Calling_Reference"]
					, URL: URL
					,	Find_Parent_Container: true
				};

				if (Parameters["Extra_Feedback"])
						Fill_Parameters["Extra_Feedback"] = Parameters["Extra_Feedback"];

				Jelly.References.Fill(Fill_Parameters);
				break;
			}
			
			// TODO - Container?
			case "container":
			{
				// TODO
				// container: $Link_Script = "Jelly.References.Fill({Namespace: "$Link_Container", URL: '$Link_URL'});";
				break;
			}
			
			// Element ID
			default:
			{
				var Container_Element = document.getElementById(Parameters["Container"]);
				if (Container_Element)
				{	
					var Fill_Parameters = {
							Element: Container_Element,
							URL: URL
						};

					// TODO - this is still going to get complicated later with non-URL references that do mathc
					if (!Container_Element.Reference)
						Fill_Parameters["Create_Reference"] = true;
						
					if (Parameters["Extra_Feedback"])
							Fill_Parameters["Extra_Feedback"] = Parameters["Extra_Feedback"];

					Jelly.References.Fill(Fill_Parameters);
				}
				// TODO - should use "On_Load" to differentiate from Ajax handling , but currently not ever called, so commented out.
				// Jelly.References.Fill({Element: Container_Element, URL: URL, On_Complete: Parameters["On_Complete"]});
				else
					console.log("Unknown link container id (" +  Parameters.Container + "). Perhaps the container is no longer in the DOM, for instance if the page was left while inner content was loading.");
				break;
			}
		}
	}
	
};